import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
const CountSchema = z.object({
    count: z.number()
});
/**
 * Get Initialize Summary Response Schema
 * One round-trip for the wizard's overview step: counts per building block
 * plus the derivations no list endpoint exposes.
 */ export const GetInitializeSummaryResponseSchema = z.strictObject({
    departments: z.object({
        count: z.number(),
        /** Departments whose manager is still unresolved (manager unset) */ unresolvedCount: z.number()
    }),
    members: z.object({
        count: z.number(),
        /** Internal users with no department — mirrors the completion gate's filter */ withoutDepartmentCount: z.number()
    }),
    /** Distinct mainRole links in use — the "distinct positions" derivation */ positions: CountSchema,
    /** Role-kind OrgFunctions (UI label: Funktionen) */ functions: CountSchema,
    /** Team-kind OrgFunctions (UI label: Teams) */ teams: CountSchema,
    systems: CountSchema,
    processes: CountSchema
});
/**
 * Get Initialize Summary Request Schema
 * GET /api/v2/initialize/summary
 */ export const GetInitializeSummaryRequestSchema = z.object({});
export const GetInitializeSummaryErrorSchema = BaseErrorSchema;

//# sourceMappingURL=get-initialize-summary.schema.js.map